import React from 'react';
import { Coord, Dimensions } from '@99designs/browser';
import catmullRomFitting from './catmullRomFitting';

interface ScribbleLayerProps {
    children: React.ReactNode;
    artboardOrigin: Coord;
    scale: number;
    artboardSize: Dimensions;
}

function ScribbleLayer({ children, artboardOrigin, artboardSize, scale }: ScribbleLayerProps) {
    const svgViewbox =
        -artboardOrigin.x / scale +
        ' ' +
        -artboardOrigin.y / scale +
        ' ' +
        artboardSize.width / scale +
        ' ' +
        artboardSize.height / scale;

    return (
        <svg
            role="img"
            width="100%"
            height="100%"
            viewBox={svgViewbox}
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                filter: 'drop-shadow(1px 1px 0.5px rgba(0,0,0,0.2)) drop-shadow(2px 2px 3px rgba(0,0,0,0.25)) ',
                pointerEvents: 'none', // Let the user right click and save the image underneath
            }}
        >
            {children}
        </svg>
    );
}

interface PathProps {
    path: Coord[];
    smooth?: boolean;
}
export function Path({ path, smooth = false }: PathProps) {
    if (path.length === 0) return null;

    let svgPath;
    if (smooth) {
        svgPath = catmullRomFitting(path);
    } else {
        svgPath =
            `M ${path[0].x} ${path[0].y}` +
            path
                .slice(1)
                .map((point: Coord) => ` L ${point.x} ${point.y}`)
                .join(' ');
    }

    return (
        <path
            key="line"
            strokeLinecap="round"
            strokeLinejoin="round"
            vectorEffect="non-scaling-stroke"
            strokeWidth="5px"
            d={svgPath}
            stroke="#fe5f50"
            fill="transparent"
        />
    );
}

export default React.memo(ScribbleLayer);
